import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  quote: string;
  avatarUrl?: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote,
  avatarUrl
}: TestimonialCardProps) {
  return <div className="bg-brand-50 rounded-2xl p-6 md:p-8 mb-6 border border-brand-100 relative" data-id="element-280">
      <div className="flex gap-1 mb-4" data-id="element-281">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-brand-500 text-brand-500" data-id="element-282" />)}
      </div>
      <blockquote className="font-serif text-lg text-gray-800 italic mb-6 leading-relaxed" data-id="element-283">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-284">
        {avatarUrl ? <img src={avatarUrl} alt={name} className="w-10 h-10 rounded-full object-cover" data-id="element-285" /> : <div className="w-10 h-10 rounded-full bg-brand-200 flex items-center justify-center text-brand-700 font-sans font-bold" data-id="element-286">
            {name.charAt(0)}
          </div>}
        <div data-id="element-287">
          <div className="font-sans font-bold text-gray-900" data-id="element-288">
            {name}, {age} ans
          </div>
          <div className="font-sans text-sm text-gray-500" data-id="element-289">{city}</div>
        </div>
      </div>
    </div>;
}